import React from 'react'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import { HiCheckCircle } from "react-icons/hi"
import { CgClose } from "react-icons/cg"

import './datafeature.css'

import academic from "../../../assets/media/pricing/dataCollectionComponent/academic.png"
import anticheat from "../../../assets/media/pricing/dataCollectionComponent/anticheat.png"
import customartwork from "../../../assets/media/pricing/dataCollectionComponent/customartwork.png"
import employmenthistory from "../../../assets/media/pricing/dataCollectionComponent/employmenthistory.png"
import personalinfo from "../../../assets/media/pricing/dataCollectionComponent/personalinfo.png"
import loginmethod from "../../../assets/media/pricing/dataCollectionComponent/loginmethod.png"


const DataFeatureTable = ({ plan }) => {
    const [popular, setpopular] = useState(true)
    const deselectCard = () => {
        setpopular(false)
    }



    const tableData = {
        featuresList: [
            {
                headName: "Personal Info (Registration Fields)",
                logo: personalinfo,
                fields: [
                    "Full Name",
                    "Email Address",
                    "Date of Birth",
                    "Gender",
                    "Identity Number",
                    "Phone Number",
                    "Nationality",
                    "Health Disability"
                ]

            },
            {
                headName: "Academic Qualifications (Registration Fields)",
                logo: academic,
                fields: [
                    "Graduation Year",
                    "Major Subject",
                    "Institute Name",
                    "Degree Program",
                    "Grading Value"
                ]
            },
            {
                headName: "Employment History (Registration Fields)",
                logo: employmenthistory,
                fields: [
                    "Current Employment",
                    "Previous Employment",
                    "Area Of Interest",
                    "Upload CV"
                ]
            },
            {
                headName: "Custom Artwork Upload",
                logo: customartwork,
                fields: [
                    "Game Registration Screen",
                    "Game End Screen",
                    "Browser Favicon"
                ]
            },
            {
                headName: "Anti-Cheat Security Features",
                logo: anticheat,
                fields: [
                    "Game Auto-Lock",
                    "Facial Recognition",
                ]
            },
            {
                headName: "Login Method",
                logo: loginmethod,
                fields: [
                    "Email Address",
                    "LinkedIn Profile"
                ]
            },
        ],
        plans: [
            {
                planBox: {
                    planName: "Free",
                    price: "$0",
                    year: "free forever",
                    url: '/free'
                },
                availiblity: [
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,

                ]
            },
            {
                planBox: {
                    planName: "Standard",
                    price: "$1,200",
                    year: "per year",
                    popular: true,
                    url: '/standard'
                },
                availiblity: [
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    false,

                ]
            },
            {
                planBox: {
                    planName: "Premium",
                    price: "$4,800",
                    year: "per year",
                    url: 'premium'
                },
                availiblity: [
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,

                ]
            },
        ]
    }

    return (
        <div style={{}} className="hidden data--feature-table lg:flex flex-wrap justify-center items-center w-[20rem] pt-[30px] sm:w-[40rem] lg:w-full mx-auto my-14 lg:my-10 ">
            <div className="feature--container w-fit my-4 ">
                <div className="plan--box px-4 invisible" >
                    <h3 className='text-3xl font-bold'>Free</h3>
                    <div className="price text-5xl my-2">
                        $12.00
                    </div>
                    <div className="btn px-2 flex justify-center">

                        <button className='bg-black w-[15rem] my-5 py-2 px-6 text-white rounded-full text-xl'>Start free trial</button>
                    </div>
                </div>
                {
                    tableData.featuresList.map((feature, index) =>
                        <div key={index}>

                            <div className="header p-500 p-2 text-white flex items-center"
                                style={{
                                    backgroundColor: '#333333',
                                    borderRadius: '4px 0 0 4px'
                                }}>
                                <div className="headLogo h-[1.5rem] mr-2">
                                    <img src={feature.logo} alt={feature.headName} className='w-full h-full' />
                                </div>
                                <div className="headName">
                                    {feature.headName}
                                </div>
                            </div>
                            {
                                feature.fields.map((field, findex) =>

                                    <div key={findex + 'f'} className="field border-b-2 py-4">
                                        {field}
                                    </div>

                                )
                            }
                        </div>
                    )
                }
            </div>

            {


                tableData.plans.map((plan, index) =>
                    <div onMouseOver={deselectCard} key={index + 'i'} className={`fields--container w-fit my-4 group ${plan.planBox.popular === popular && 'bg-[#FFD700]'}`}>
                        <div className={`planBox px-4 border-radius-10 ${plan.planBox.popular === popular && 'bg-[#FFD700]'}`}>
                            <h3 className='text-3xl font-bold'>{plan.planBox.planName}</h3>
                            {plan.planBox.planName === "Standard" ? <span className='recommendation'>Recommended</span> : null}
                            <div className="price text-5xl my-2">
                            </div>
                            <div className="btn px-2 flex justify-center">

                                <Link to={'/free'}>
                                    <button className='bg-white w-[15rem] my-5 py-2 border-2 border-[#333333] px-6 text-black rounded-full text-xl'>Start free trial</button>

                                </Link>
                            </div>
                        </div>

                        <div className="header p-5 text-white">

                        </div>
                        {
                            plan.availiblity.map((isAvailable, findex) =>
                                <div key={findex + 'm'} className="avalibilityBox">

                                    {

                                        (findex === 8 || findex === 13 || findex === 17 || findex === 20 || findex === 22) &&

                                        <div className="header p-5 text-white group-hover:bg-[#FFD700]">

                                        </div>
                                    }


                                    <div className="field border-b-2 py-4 flex justify-center" key={findex}>
                                        {isAvailable ? <HiCheckCircle className={`rounded-3xl text-2xl text-[#FFD700] group-hover:text-[#333333] ${plan.planBox.popular === popular && '!text-[#333333]'}`} /> : <CgClose className={`rounded-3xl text-2xl text-[#FFD700] group-hover:text-[#333333] ${plan.planBox.popular === popular && '!text-[#333333]'}`} />}
                                    </div>
                                </div>

                            )
                        }
                    </div>
                )
            }
        </div>
    )
}

export default DataFeatureTable